import { configureStore } from '@reduxjs/toolkit';
import { inventoryApi } from './services/inventoryApi';
import { deliveryZoneRequestApi } from './services/deliveryZoneRequestApi';

export const store = configureStore({
    reducer: {
        [inventoryApi.reducerPath]: inventoryApi.reducer,
        [deliveryZoneRequestApi.reducerPath]: deliveryZoneRequestApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(inventoryApi.middleware, deliveryZoneRequestApi.middleware),
});

export default store;
